import { Container, Grid, Tab, Tabs } from "@mui/material";
import {
  PORTFOLIO_CHART_TYPES,
  PORTFOLIO_TYPES,
} from "../Components/constants";
import {
  getPortfolioChart,
  getPortfolioInvestmentForm,
  getPortfolioTradeAvgForm,
} from "store/slices/portfolio/portfolioSlice";
import { useParams, useSearchParams } from "react-router-dom";

import BackButton from "components/BackButton";
import BoxPortfolioTradeCoin from "./Component/BoxPortfolioTradeCoin";
import BoxPortfolioTradeCoinList from "./Component/BoxPortfolioTradeCoinList";
import DateSort from "../Components/PortfolioCard/Components/DateSort";
import TablePortfolioTradeCoin from "./Component/TablePortfolioTradeCoin";
import TablePortfolioTradeCoinList from "./Component/TablePortfolioTradeCoinList";
import styled from "@emotion/styled";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import useIsMobileView from "hooks/useIsMobileView";

function PortfolioDetails() {
  const dispatch = useDispatch();
  const isMobileView = useIsMobileView();
  const { type } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const walletType = +searchParams.get("walletType") || 0;

  const handleChangeWalletType = (_, newValue) => {
    dispatch(getPortfolioChart({ walletTypeId: newValue }));
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      walletType: newValue,
    });
  };

  const handleGetFormValue = (type) => {
    if (type === PORTFOLIO_TYPES.trade.key) {
      dispatch(getPortfolioTradeAvgForm());
    } else {
      dispatch(getPortfolioInvestmentForm());
    }
  };

  useEffect(() => {
    handleGetFormValue(type);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <BackButton text="Portfolio" to="/portfolio" />
        </Grid>
      </Grid>
      <DateSort />

      {!isMobileView && (
        <Grid container>
          <Grid item xs={12}>
            <TabsStyle value={walletType} onChange={handleChangeWalletType}>
              {PORTFOLIO_CHART_TYPES?.map((type) => (
                <Tab label={type.name} value={type.key} />
              ))}
            </TabsStyle>
          </Grid>
        </Grid>
      )}

      {isMobileView ? <BoxPortfolioTradeCoin /> : <TablePortfolioTradeCoin />}

      {isMobileView ? (
        <BoxPortfolioTradeCoinList />
      ) : (
        <TablePortfolioTradeCoinList />
      )}
    </Container>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    maxWidth: "300px",
    margin: "auto",
    justifyContent: "space-between",
  },
}));
export default PortfolioDetails;
